export default {
    init() {

        $(document).on('click', '.google-translate-trigger', function() {
            const $thisButton = $(this)
            let inputText = $thisButton.closest('.translate-wrapper').find('.slovensko').val()
            const $outputElement = $thisButton.closest('.translate-wrapper').find('.anglesko')

            if (inputText && $outputElement && $outputElement.length) {
                translateGoogle(inputText, $outputElement)
                $thisButton.addClass('translated')
            }
        })
        

        function translateGoogle(sourceText = '', outputElement = false) {
            
            if (sourceText == '') return
            
            var sourceLang = 'auto';
            var targetLang = 'en';
            
            var url = "https://translate.googleapis.com/translate_a/single?client=gtx&sl="+ sourceLang + "&tl=" + targetLang + "&dt=t&q=" + encodeURIComponent(sourceText);
            
            $.getJSON(url, function (data) {
                let resultString = ''
                if (Array.isArray(data) && Array.isArray(data[0])) {
                    resultString = data[0].map(function(chunk) { return chunk[0] || '' }).join('')
                }
                if (resultString && /[A-Za-z]/.test(resultString) && resultString === resultString.toUpperCase()) {
                    resultString = resultString.toLocaleLowerCase()
                }
                outputElement.val(resultString)
                // trigger input so autoresize runs after async update
                outputElement.trigger('input')
            })

        }
        
    }
}